var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleEnabled && _vm.showBonus)?_c('a',{staticClass:"link link-bonus",attrs:{"href":"#"},on:{"click":_vm.goToHistory}},[_c('span',[_vm._v(_vm._s(_vm.formattedBonus))]),_c('BonusIcon')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }